<template>
  <div class>
    <v-toolbar dark :color="this.$gf.headerColor()">
      <v-toolbar-title>
        <v-icon class="icon">fa-plus</v-icon>Add Customer
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn fab small  @click="closePanel" :color="this.$gf.headerColor()">
        <v-icon dark>fa-times</v-icon>
      </v-btn>
    </v-toolbar>
    <div id="slideout-container" class="scroll-y">
        <v-stepper v-model="e1" class="no-transition" alt-labels non-linear>
          <v-stepper-header v-if="selectCoursesButton">
            <v-stepper-step :complete="e1 > 1" step="1">Customer Details</v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="e1 > 2" v-if="this.e1 == 2" step="2">Select Courses</v-stepper-step>
             <v-stepper-step
            :complete="e1 > 2"
            style="text-align: center"
            v-else
            step="2"
            >Select Courses</v-stepper-step
          >
          </v-stepper-header>
          <v-stepper-items>
            <v-stepper-content step="1" class="max-height-list scroll-y">
    <v-container class="pa-0">
      <v-layout>
        <v-flex xs12>
          <v-form>
            <v-text-field
              :error-messages="messages.first_name"
              v-model="user.first_name"
              :label="$globalConfig.APP_NAME == 'senso' ? 'LEAD FIRST NAME' : 'Admin First Name'"
              type="text"
            ></v-text-field>
            <v-text-field
              :error-messages="messages.last_name"
              v-model="user.last_name"
              :label="$globalConfig.APP_NAME == 'senso' ? 'LEAD LAST NAME' : 'Admin Last Name'"
              type="text"
            ></v-text-field>
            <v-text-field
              :error-messages="messages.email"
              v-model="user.email"
              :label="$globalConfig.APP_NAME == 'senso' ? 'LEAD EMAIL' : 'Admin Email'"
              type="text"
            ></v-text-field>
            <v-text-field
              :error-messages="messages.company_name"
              v-model="user.company_name"
              :label="$globalConfig.APP_NAME == 'senso' ? 'ORGANIZATION NAME' : 'Company Name'"
              type="text"
            >
            </v-text-field>
            <div v-if="$globalConfig.APP_NAME === 'partner'">
              <v-select
                    :items="noOfEmployeesOptions"
                    v-model="user.banding"
                    item-value="id"
                    item-text="name"
                    label="Number of Users"
                    attach
                    hide-no-data :loading="bandingLoading"
                    :disabled="bandingLoading"
                    return-object
                    @change="onBandingOptionChange"
            >
            <template #progress>
                            <v-progress-circular indeterminate color="primary" size="24"></v-progress-circular>
                        </template>
          </v-select>
          <!-- Loading Spinner -->
          <div v-if="loadingPackages" class="d-flex align-center mt-4">
            <v-progress-circular indeterminate color="primary" class="mr-2"></v-progress-circular>
            <span>Loading packages...</span>
          </div>
          <!-- Conditionally Show Second Dropdown -->
            <v-select
              v-if="packageOptions.length > 0"
              v-model="user.package"
              :items="packageOptions"
              item-value="id"
              :item-text="formatPackageLabel"
              label="Select Package"
              class="mt-4"
              return-object
              @change="onPackageOptionChange"
            ></v-select>
            <v-select
                    v-model="user.manager_id"
                    :items="accountManagerList"
                    item-text="full_name"
                    item-value="id"
                    label="Assign Manager"
                    hint="Choose Manager"
                    class="mt-4"
                    :menu-props="{ maxHeight: '400' }"
                    persistent-hint
                    attach
                    v-if="$globalConfig.APP_NAME === 'partner' && this.$store.getters.level != 5"
            ></v-select>
            <!-- <drop-zone
                    :type="type"
                    :accepted="accepted"
                    class="mt-5"
                    text="Click here to upload Customer Logo (155 x 33)"
            ></drop-zone>
            <p class="block text-left mt-4 caption">
              Max upload filesize: 1MB<br />
              Dimension should be 155 x 33<br/>
              Accepted file formats: png, jpg
            </p> -->
            <CompanyLogoUpload 
                class="mt-5 mb-5"
                text="Click here to upload Customer Logo"
                :type="'company-logo'"
                :accepted="'image/jpg,image/jpeg,image/png'"
              />
              <p class="block text-left mt-4 caption">
                Max upload filesize: 1MB<br />
                Recommended Dimensions: 475 × 115<br />
                Accepted formats: PNG, JPG
              </p>
            </div>
          </v-form>
        </v-flex>
      </v-layout>
    </v-container>
    </v-stepper-content>
     <v-stepper-content step="2" class="max-height-list scroll-y">
      <v-container class="scroll-y">
        <v-layout>
        <v-flex xs12>
          <p class="font-weight-bold text-center mb-2"> You can select up to {{ this.maxCourse }} courses.</p>
      <div style="border:1px solid rgba(0, 0, 0, 0.12);">
        <div class="filterSection">
        <v-text-field
          v-model="search"
          label="Search Courses"
          placeholder="Search Courses"
          type="text"
          @change="applyCourseSearch"
          append-icon="fa-search"
          class="filter-user"
        ></v-text-field>
        <v-select :items="categories" :clearable="true" item-text="name" item-value="id" ref="categoryFilterBox"
                placeholder="Filter course categories" multiple small-chips class="categories" v-model="selectedCategory"
                v-on:change="filterCoursesByCategories($event)" menu-props="content-class: dropdown-below" @click:clear="handleClear">
                <template v-slot:prepend-item>
            <v-list-item ripple @click="toggleSelectAll">
              <v-list-item-action>
                <v-checkbox :input-value="selectAll" />
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Select All</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
          </template>
          <template v-slot:selection="{ item, index }">
                <template v-if="index < 2">
                  <v-chip :title="item.name">{{ $gf.truncateText(item.name, 6) }}</v-chip>
                </template>
                <template v-if="index === 2">
                  <v-chip>...</v-chip>
                </template>
              </template>
          </v-select> 
          </div>
          <v-divider></v-divider>
        <v-expansion-panels  v-model="panel"
          multiple>
          <v-expansion-panel>
            <!-- <v-expansion-panel-header expand-icon="mdi-menu-down" color="grey50" class="assigned-user-heading assigned-user-heading2">Default Courses</v-expansion-panel-header> -->
              <v-expansion-panel-content>
                <v-skeleton-loader v-if="loading && isTabletOrDesktop"  type="table" :types="{ 'table-heading': '','table-thead' : 'heading@4' ,'table-row':'text@4' }" class="slider-table"></v-skeleton-loader>
                <v-skeleton-loader v-if="loading && !isTabletOrDesktop" type="table" :types="{ 'table-heading': '', 'table-thead' : 'heading@1' ,'table-row':'text@1'}" class="slider-table"></v-skeleton-loader>
                <v-data-table
                  v-model="selected"
                  :headers="headers"
                  v-show="!loading"
                  :items="courses"
                  show-select
                  item-key="id"
                  class="mb-5 enrol-user-list-tbl"
                  :footer-props="{
                  'items-per-page-options': [5,10,15]
                  }"
                  @toggle-select-all="selectAllToggle"
                   @input="handleSelection"
                   @update:items-per-page="onItemsPerPageChange"
                >
                
                </v-data-table>
              </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </div>
      </v-flex>
      </v-layout>
      </v-container>
     </v-stepper-content>
    </v-stepper-items>
    </v-stepper>
    </div>
    <v-footer :absolute="$globalConfig.APP_NAME === 'senso'" height="68">
      <v-flex px-4 py-4 text-right v-if="loading">
          <v-btn v-if="loading" color="primary" loading></v-btn>
      </v-flex>
      <v-flex px-4 py-4 text-right v-else>
        <div v-if="e1 == 1">
        <v-btn v-if="!s3Uploading" color="primary" @click="closePanel" class="mr-2">Cancel</v-btn
        >
        <v-btn color="primary" @click="addUser" v-if="!selectCoursesButton" :disabled="addCustomerButtonDisabled">Add Customer</v-btn>
        <v-btn color="primary" @click="e1 = 2" v-if="selectCoursesButton">Select Courses</v-btn>
        </div>
        <div v-if="e1 == 2">
          <v-btn color="grey300" class="mr-4" @click="e1 = 1"
            >Back</v-btn
          >
          <v-btn
            color="primary"
            class="add-course-button"
            @click="addUser" 
            >Save</v-btn
          >
        </div>
      </v-flex>
    </v-footer>
  </div>
</template>
<script>
import { EventBus } from '@/event-bus.js';
import userAPI from '@/api/user.js';
// import DropZone from '@/components/global/Dropzone';
import CompanyLogoUpload from "@/components/global/CompanyLogoUpload";
import companyAPI from '@/api/company.js';
import courseAPI from "@/api/course.js";

export default {
  name: 'AddOwner',
  components: {
    // DropZone,
    CompanyLogoUpload
  },
  props: {
    params: {
      type: String,
      default: null,
    },
    id: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      type: "company-logo",
      accepted: "image/jpg,image/jpeg,image/png",
      loading: false,
      accountManagerList: [],
      user: {},
      messages: {},
      successMessage: 'Customer Successfully Added.',
      errorMessage: "Oops, something went wrong! Please check information is correct.",
      noOfEmployeesOptions: [],
      bandingLoading: false,
      packageOptions: [],
      loadingPackages: false,
      selectCoursesButton: false,
      e1: 1,
      categories: [],
      selectedCategory: [],
      headers: [
        { text: "Course", value: "name" }
      ],
      serverItemsLength:0,
      courses: [],
      selected: [],
      search: "",
      searchParams: "",
      panel: [0,1],
      maxCourse: 0,
      itemsPerPage: 10,
      maxSelected: false,
      addCustomerButtonDisabled: false,
    };
  },
  computed: {
    s3Uploading() {
      return this.$store.getters.s3Uploading;
    },
    isTabletOrDesktop() {
      const width = this.$vuetify.breakpoint.width;
      return width >= 820;
    },
    selectAll() {
      return this.selectedCategory.length === this.categories.length;
    },
    selectedArray: function() {
      let selectedCourses = [];
      this.selected.map(x => {
        selectedCourses.push(x.id);
      });
      return selectedCourses;
    },
  },
  mounted() {
    this.$store.dispatch('setS3Uploading', false);
    if(this.$globalConfig.APP_NAME === 'partner'){
        this.getAccountManagerList();
        this.getBandings();
    }
  },
  watch: {
  },
  methods: {
    closePanel() {
      this.$emit('closePanel', {});
    },
    addUser() {
      if(this.$globalConfig.APP_NAME === 'partner'){
        this.user.product = 2;
        this.user.modules = this.selectedArray;
        if(this.selectedArray && this.selectedArray.length != this.maxCourse){
          this.$snotify.warning("A minimum of " + this.maxCourse + " courses must be selected as per the package limit.");
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
         return;   
        }
      }
      this.loading = true;
      if (this.$store.getters.level == 4) {
        userAPI
          .createOwner(this.user, this.id,this.$store.getters.s3Url,this.$store.getters.fileDetails)
          .then(() => {
            this.closePanel();
            EventBus.$emit('USERS_UPDATED', this.params);
            this.$snotify.success(this.successMessage);
            setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
          })
          .catch((err) => {
            this.valid = false;
            this.messages = this.$gf.errorResponse(err);
            this.$snotify.error(this.errorMessage);
            this.loading = false;
            setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
          });
      } else {
        userAPI
          .createOwner(
            this.user,
            this.$store.getters.partnerID,
            this.$store.getters.s3Url,
            this.$store.getters.fileDetails
          )
          .then(() => {
            this.closePanel();
            EventBus.$emit('USERS_UPDATED', this.params);
            this.$snotify.success(this.successMessage);
            setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
          })
          .catch((err) => {
            this.valid = false;
            this.messages = this.$gf.errorResponse(err);
            this.$snotify.error(this.errorMessage);
            this.loading = false;
            setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
          });
      }
    },
    getAccountManagerList() {
      userAPI.getManagers(this.$store.getters.user.id).then(response => {
        this.accountManagerList = response.data.data;
      });
    },
    getBandings(){
      this.bandingLoading = true;
      companyAPI
        .getPartnerBandings()
        .then((res) => {
          this.bandingLoading = false;
          this.noOfEmployeesOptions = Object.values(res.data.banding);
        });
    },
    onBandingOptionChange(option){
      this.packageOptions = [];
      this.user.package = null;
      this.selectCoursesButton = false;
      this.maxCourse = 0;
      
        this.addCustomerButtonDisabled = true;
        this.loadingPackages = true;
        companyAPI.getPartnerBandingPackages(option.id).then((res) => {
            this.loadingPackages = false;
            const packageLists = Object.values(res.data.package);
            this.packageOptions = packageLists.length > 1 ? Object.values(res.data.package) : [];
            if(this.packageOptions.length == 0){
                        this.addCustomerButtonDisabled = false;
            }
          });
    },
    onPackageOptionChange(option){
      this.selectCoursesButton = false;
      this.maxCourse = 0;
      if(option.max != null){
        this.maxCourse = option.max;
        this.selectCoursesButton = true;
      }else{
        this.addCustomerButtonDisabled = false;
      }
      if (!this.categories.length){
        this.getAllCourseCategories();
        this.getAllDefaultCourses();
      }
    },
    getAllDefaultCourses() {
      this.loading = true;
      courseAPI.getDefaultCourse(this.searchParams).then(response => {
        this.loading = false;
        this.courses = response.data.data;
      });
    },
    applyCourseSearch() {
      this.searchParams = '';
      
      this.searchParams = this.search && this.search.length > 0
        ? '?search=name:' + this.search : '';

      if (this.selectedCategory.length) {
        this.searchParams += this.searchParams == '' ?  
        '?categories=' + this.selectedCategory.toString()
        : '&categories=' + this.selectedCategory.toString();
      }

      this.getAllDefaultCourses();      
    },
    getAllCourseCategories() {
        courseAPI.getAllCourseCategories().then(response => {
            this.categories = response.data.data;
        });
        },
    filterCoursesByCategories(){
      this.applyCourseSearch();      
    },
    handleClear(){
      const dropdown = this.$refs.categoryFilterBox.$el;
      dropdown.style.removeProperty("overflow");
    },
    toggleSelectAll() {
      if (this.selectAll) {
        this.selectedCategory = [];
      } else {
        this.selectedCategory =  this.categories.map((cat) => cat.id);
      }

      this.applyCourseSearch()
    },
    selectAllToggle({ value, items }) {
      if (value) {

       if (this.selected.length >= this.maxCourse) {      
          this.maxSelected = true;    
          this.$snotify.warning("Only " + this.maxCourse + " courses are selectable due to the package limit.");
          setTimeout(() => {
                this.$gf.removeBackdrop();
                this.maxSelected = false;
            },300);
          return;
        }
        const remaining = this.maxCourse - this.selected.length;

        const selectedIds = items.slice(0, remaining);

        this.selected = [...this.selected, ...selectedIds];        
      } else {
        const removed = this.itemsPerPage;
        this.selected = this.selected.slice(0, removed);
      }
    },
    handleSelection(newSelection) {
      if (newSelection.length > this.maxCourse) {
        this.$nextTick(() => {
          this.selected = newSelection.slice(0, this.maxCourse);
        });
        if(!this.maxSelected){
        this.maxSelected = true;
        this.$snotify.warning("Only " + this.maxCourse + " course are selectable due to the package limit.");
        setTimeout(() => {
                this.$gf.removeBackdrop();
                this.maxSelected = false;
            },300);
        }
      } else {
        this.selected = newSelection;
      }
    },
    onItemsPerPageChange(value) {
      this.itemsPerPage = value;
    },
    formatPackageLabel(item) {
      if (!item) return '';
      // Add your custom logic here
      return `${item.name}  ${item.max ? ' (Max Courses: ' + item.max + ')': ''}`;
    }
  },
};
</script>
<style scoped>
.slideout .container{
  padding: 0 !important;
}
</style>